import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Plus } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Seo, breadcrumb } from '../components/Seo';
import { useAuth } from '../context/AuthContext';
import { useSocialPosts } from '../components/SocialFeed';
import { SocialPostCard } from '../components/SocialPostCard';
import { AddSocialPostDialog } from '../components/AddSocialPostDialog';
import { useT } from '../context/LanguageContext';

const Videos = () => {
  const { t } = useT();
  const { user } = useAuth();
  const { posts, status, reload, update, remove, add } = useSocialPosts();
  const [open, setOpen] = useState(false);

  return (
    <div className="bg-black min-h-screen text-white" data-testid="videos-page">
      <Seo title="Videoar | Refuel Weekend 2027" description="Sjå videoar frå Refuel Weekend – TikTok, Instagram og eigne klipp frå Hjeltefjorden Arena." path="/videoar" jsonLd={breadcrumb([{ name: 'Refuel Weekend', path: '/' }, { name: 'Videoar', path: '/videoar' }])} />
      <Navbar />
      <main className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 md:py-16">
        <Link to="/#videoar" data-testid="videos-back-link" className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/50 border border-white/15 text-white hover:bg-black/70 transition-colors text-sm mb-8"><ArrowLeft size={16} /> Tilbake</Link>
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div>
            <p className="text-[#ff2e2e] font-bold uppercase tracking-widest text-sm mb-2">Alle videoar</p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight" style={{ fontFamily: "'Oktah Round', sans-serif" }}>Sjå stemninga</h1>
            <p className="text-white/60 mt-3">Lik videoane du digger og lagre favorittane dine – dei dukkar opp på medlemssida di.</p>
          </div>
          {user?.is_admin && (
            <button onClick={() => setOpen(true)} data-testid="social-add-button" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#ff2e2e] text-black font-bold hover:bg-[#ff4d4d] transition-colors"><Plus size={18} /> Legg til video</button>
          )}
        </div>
        {status === 'loading' ? (
          <p role="status" className="py-10 text-center text-white/50">{t('Lastar videoar…')}</p>
        ) : status === 'error' ? (
          <div role="alert" data-testid="videos-error" className="rounded-3xl border border-amber-400/20 bg-amber-400/5 p-10 text-center text-white/70">
            <p>{t('Videoane kunne ikkje lastast akkurat no.')}</p>
            <button type="button" onClick={reload} className="mt-3 font-semibold text-[#ffb400] hover:text-white">{t('Prøv igjen')}</button>
          </div>
        ) : posts.length === 0 ? (
          <div data-testid="videos-empty" className="rounded-3xl border border-dashed border-white/15 p-10 text-center text-white/50">Ingen videoar enno.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 max-w-sm sm:max-w-none mx-auto items-start" data-testid="videos-grid">
            {posts.map((p) => <SocialPostCard key={p.id} post={p} onChange={update} onDelete={remove} />)}
          </div>
        )}
      </main>
      <AddSocialPostDialog open={open} onClose={() => setOpen(false)} onCreated={add} />
      <Footer />
    </div>
  );
};

export default Videos;
